import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Registers 'de-DE' locale data so a `DatePipe` can format with it when explicitly requested
// (`| date: format : undefined : 'de-DE'`). Deliberately does NOT change the app-wide default `LOCALE_ID`
// (still 'en-US') — that would also silently re-format every date in the separate, out-of-scope
// admin/operator portal, which this rebrand explicitly leaves untouched. Only the customer-facing
// components that pass 'de-DE' explicitly are affected.
registerLocaleData(localeDe);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
